@if (selectedItem) {
  <form class="formly" #thisForm="ngForm" role="form" novalidate [formGroup]="form" (ngSubmit)="save(selectedItem)">
    <p-panel> <p-header>
      @if (selectedItem?.id) {
        <h2>Editing '{{originalName}}'</h2>
      }
      @if (!selectedItem?.id) {
        <h2>Create New {{entityName}}</h2>
      }
    </p-header>
    <div class="grid">
      <!-- Item specifics start here -->
      <div class="col-6 form-group">
        <node-unique-name [item]="selectedItem" [service]="itemService" field="serialnr" placeholder="Serial Nr" [input]="$any(form.controls.serialnr)"></node-unique-name>
      </div>
      <div class="col-6 form-group">
        <node-unique-name [item]="selectedItem" [service]="itemService" [input]="$any(form.controls.name)"></node-unique-name>
      </div>
      <div class="col-6 form-group">
        <mat-form-field class="full-width">
          <input matInput placeholder="Description" type="text" id="description" name="description" formControlName="description"/>
        </mat-form-field>
      </div>
      @if (errorMsgs?.length) {
        <ul class="col-12 form-group" class="alert alert-danger">
          @for (err of errorMsgs; track err) {
            <li>{{err}}</li>
          }
        </ul>
      }
      <!-- Item specifics end here -->
    </div>
    <p-footer>
      <button mat-raised-button color="primary" type="submit" [disabled]="!thisForm.form.valid">Submit</button>
      <button mat-raised-button (click)="cancel(selectedItem)" type="button">Cancel</button>
    </p-footer> </p-panel>
  </form>
}

@if (!selectedItem) {
  <div>{{entityName}} does not exists</div>
}
